module.exports = __webpack_public_path__ + "components/resort-snow-depths-snippet/static/mountain-792b8b226c4bb983673ae4814b72090e.svg";